export default __webpack_public_path__ + "static/media/it-gif1.9ad7af23.gif";